function renderSidebarItems(items) {
  var $sidebar = $('.sidebar-items');
  $sidebar.empty(); // Clear previous items

  items.forEach(function(item) {
    // Render each item
    var $item = $('<div>').addClass('sidebar-item');
    $item.append('<div class="item-title">' + item.title + '</div>');
    $item.append('<div class="item-quantity">Qty: ' + item.quantity + '</div>');
    $item.append('<div class="item-price">' + Shopify.formatMoney(item.price * item.quantity) + '</div>');

    $sidebar.append($item);
  });
}

function openQuickCart($) {
  var $modal = $('.quick-checkout'),
      $message = $modal.find('.added-message'),
      $price = $modal.find('.price'),
      $cartButton = $('.site-header-cart');

  $.get('/cart.json', function(response) {
    $price.html(Shopify.formatMoney(response.total_price));

    if (response.item_count > 0) {
      $('.site-header-cart--count').addClass('visible').attr('data-header-cart-count', response.item_count);
    }

    
    // Merge selected items with cart items
    var mergedItems = response.items.concat(self.state.selectedItems);

    // Pass merged items to the sidebar for rendering
    renderSidebarItems(mergedItems);

    $modal.attr('data-active', true);
    $message.attr('data-active', true);

    setTimeout(function() {
      $modal.attr('data-active', false);
      $cartButton.attr('data-animate', true);
    }, 5000);

    setTimeout(function() {
      $message.attr('data-active', false);
      $cartButton.removeAttr('data-animate');
    }, 3000);
  });
}

ProductSet.init = function($) {
  var self = this;

  // this.MOBILE_BREAKPOINT = 1023;
  this.MOBILE_BREAKPOINT = 0;

  var $set = $('.set-product'),
      $railing = $set.find('.railing');

  if (!$set.length) {
    console.warn("Product set expects to '.product-set' to exist, but it doesn't");
  }

  function valueForOption(option, options, values) {
    var index = _.findIndex(options, function(_option) {
      if (typeof(option) == 'string' && typeof(_option) == 'string') {
        return option.toLowerCase() == _option.toLowerCase();
      } else {
        return false;
      }
    });

    // Return the value, as a string
    return '' + values[index];
  }

  var Unit = function(params) {
    this.id = '' + params.id;
    this.options = params.options;
    this.values = params.values;
    this.title = this.valueForOption('unit');
    this.grade = this.valueForOption('grade');
    this.image = params.image;
    this.price = params.price;
    this.compareAtPrice = params.compare_at_price || params.price;
    this.savings = this.compareAtPrice - this.price;
  };

  Unit.prototype.valueForOption = function(option) {
    return valueForOption(option, this.options, this.values);
  };

  Unit.prototype.totalPrice = function(quantity) {
    return this.price * quantity;
  };

  Unit.prototype.add = function(e) {
    e.preventDefault();
    console.log("press +select");
    var id = $(this).attr('data-variant-id'),
        quantity = parseInt($(this).find('[name="quantity"]').val()),
        $button = $(this).find('.add-to-cart button'),
        unit = _.find(self.state.units, { id: id });
    
    if (!unit) {
      throw("Unit with id '"+id+"' not found");
    }

    if (!self.state.selectedSwatch) {
      alert("Please select a color first");
      return;
    }

    if (self.isBuilderEnabled()) {
      var prev = _.find(self.state.selectedItems, function(_u) {
        return _u.unit.id == id;
      });
  
      if (prev) {
        self.removeItem(prev);
      } else {
        console.log("push");
        self.state.selectedItems.push({
          quantity: quantity,
          unit: unit,
          increase: function(e, b) {
            b.item.quantity++;
            self.state.calculateTotals(self.state.selectedItems);
          },
          decrease: function(e, b) {
            if (b.item.quantity > 1) {
              b.item.quantity--;
            }
  
            self.state.calculateTotals(self.state.selectedItems);
          },
          remove: function(e, b) {
            self.removeItem(b.item);
            self.state.calculateTotals(self.state.selectedItems);
          }
        });
      }
  
      self.state.calculateTotals(self.state.selectedItems);
      
      console.log("calculate");
      $railing.scrollTop($railing.outerHeight());
      var $mainATC = $railing.find('.add-to-cart button').removeAttr('data-animate');
      setTimeout(function() {
        $mainATC.attr('data-animate', true);
      }, 15);
    } else {
      var item = {
        id: unit.id,
        title: unit.title,
        quantity: quantity,
        properties: {
          grade: self.state.selectedSwatch.grade,
          color: self.state.selectedSwatch.color
        }
      };

      $button.attr('data-state', 'loading');

      self.addItemsToCart([item], function(success) {
        $button.attr('data-state', success ? 'complete' : 'ready');

        if (self.enableQuickCheckout) {
          openQuickCart($);
        }
      });
    }

  }
  

  var Swatch = function(params) {
    this.id = '' + params.id;
    this.options = params.options;
    this.values = params.values;
    this.grade = this.valueForOption("grade");
    this.color = this.valueForOption("color");
    this.description = params.description;
    this.image = params.image;
    this.imageDisplay = params.image_display;
  }

  Swatch.prototype.valueForOption = function(option) {
    return valueForOption(option, this.options, this.values);
  };

  Swatch.prototype.toggle = function() {
    var id = this.getAttribute('data-id');

    self.selectSwatch(id);
  }

  Swatch.prototype.preview = function() {
    var id = this.getAttribute('data-id');
    var swatch = _.find(self.swatches, { id: id });

    self.state.previewSwatch = swatch;
  }

  Swatch.prototype.unpreview = function() {
    self.state.previewSwatch = self.state.selectedSwatch;
  }

  this.units = this.variantsData.map(function(variant) {
    return new Unit(variant);
  });

  this.swatches = this.swatchesData.map(function(swatch) {
    return new Swatch(swatch);
  });

  this.isBuilderEnabled = function() {
    var isMobile = window.matchMedia('(max-width: ' + this.MOBILE_BREAKPOINT + 'px)').matches;
    return isMobile ? false : this.enableBuilderDesktop;
  }
  
    this.selectSwatch = function(id) {
    if (self.state.selectedSwatch && id == self.state.selectedSwatch.id) {
      var swatch = _.find(self.swatches, { id: id });
      self.state.selectedSwatch = swatch;
      self.state.selectedSwatchId = id;
    } else {
      var swatch = _.find(self.swatches, { id: id });
      self.state.selectedSwatch = swatch;
      self.state.selectedSwatchId = id;
      this.state.previewSwatch = swatch;
    }

    // fixed by Dmytro
    setDicsountPrice();
  }

  this.selectGrade = function(grade) {
    if (typeof(grade) != 'string') {
      throw("expected '"+grade+"' to be a string");
    }

    var units = _.filter(this.units, function(unit) {
      return unit.grade.toLowerCase() == grade.toLowerCase();
    });

    this.state.swatches = _.filter(this.swatches, function(swatch) {
      return swatch.grade.toLowerCase() == grade.toLowerCase();
    });

    var itemsToRemove = [];

    // Attempt to swap out the product for that grade
    _.each(this.state.selectedItems, function(item) {
      var title = item.unit.title;

      var swapUnit = _.find(units, { 
        grade: grade,
        title: title
      });

      if (swapUnit) {
        item.unit = swapUnit;
      } else {
        console.warn("No matches for grade '"+grade+"' and unit '"+title+"'");
        itemsToRemove.push(item);
      }
    });

    // Remove each item that we didn't find a match for
    _.each(itemsToRemove, function(item) {
      self.removeItem(item);
    });

    this.state.units = units;
    this.state.selectedGrade = grade;
    //Without Automatically by kkm
    this.selectSwatch(null);
    // Automatically select the first swatch after selecting a grade
    if (this.state.swatches.length > 0) {
      this.selectSwatch(this.state.swatches[0].id);
    } else {
      // this.selectSwatch(null);
    }

    self.state.calculateTotals(self.state.selectedItems);
  }

  this.availableGrades = function() {
    var self = this;

    var grades = _.uniq(_.map(this.units, function(unit) {
      return unit.grade;
    }));

    return _.map(grades, function(grade) {
      return {
        name: grade,
        select: function() {
          self.selectGrade(grade);
        }
      };
    });
  }

  this.removeItem = function(item) {
    var index = self.state.selectedItems.indexOf(item);
    self.state.selectedItems.splice(index, 1);
  };

  this.calculateTotalOriginalPrice = function(items) {
    if (items.length > 0) {
      return _.reduce(items, function(sum, item) {
        return sum + (item.unit.compareAtPrice * item.quantity);
      }, 0);
    } else {
      return 0;
    }
  };

  this.calculateTotalPrice = function(items) {
    if (items.length > 0) {
      return _.reduce(items, function(sum, item) {
        return sum + (item.unit.price * item.quantity);
      }, 0);
    } else {
      return 0;
    }
  };

  this.calculateTotalSavings = function(items) {
    var original = self.calculateTotalOriginalPrice(items),
        total = self.calculateTotalPrice(items);

    return original - total;
  }

  this.addItemsToCart = function(queue, callback) {
    var item = queue[0];

    $.ajax({
      url: '/cart/add',
      method: 'POST',
      data: $.param(item),
      success: function() {
        console.log("Added " + item.title);

        queue.shift();

        if (queue.length > 0) {
          self.addItemsToCart(queue, callback);
        } else {
          callback(true);
        }
      },
      error: function() {
        callback(false);
      }
    });
  }

  // State to be used by Rivets
  this.state = {
    discountPercent: 10,
    selectedGrade: null,
    selectedSwatch: null,
    units: [],
    selectedItems: [],
    swatches: [],
    availableGrades: this.availableGrades(),
    calculateTotals: function(items) {
      console.log("total");
      this.totalOriginalPrice = self.calculateTotalOriginalPrice(items);
      
      if (this.discountPercent > 0) {
        tempTotalPrice = self.calculateTotalPrice(items);
        this.totalPrice = tempTotalPrice * (100 - discountPercent) / 100;
        this.totalSavings = self.calculateTotalSavings(items) + tempTotalPrice * discountPercent / 100;
      } else {
        this.totalPrice = self.calculateTotalPrice(items);
        this.totalSavings = self.calculateTotalSavings(items);
      }

    },
    handleSelectSwatch: function() {
      self.selectSwatch(this.value);
    },
    addToCart: function(e, b) {
      if (!self.state.selectedSwatch) {
        alert("Please select a grade and color first");
        return;
      }

      var $button = $(e.target).closest('button');

      $button.attr('data-state', 'loading');

      var queue = _.map(b.selectedItems, function(item) {
        return {
          id: item.unit.id,
          title: item.unit.title,
          quantity: item.quantity,
          properties: {
            grade: self.state.selectedSwatch.grade,
            color: self.state.selectedSwatch.color
          }
        }
      });

      self.addItemsToCart(queue, function(success) {
        if (success) {
          self.state.submitting = true;
          location.href = '/cart';
        } else {
          alert("There was an error adding items to cart");
          $.get('/cart/clear');
          $button.attr('data-state', 'ready');
        }
      });
    }
  };

  window.addEventListener('beforeunload', function(e) {
    if (!self.state.submitting && self.state.selectedItems.length > 0) {
      // e.preventDefault();
      // e.returnValue = '';

      return "You have selected items but haven't added them to your cart. Are you sure you want to leave this page?";
    }
  });

  // Attempt to select the first grade
  if (this.units[0]) {
    this.selectGrade(this.units[0].grade);
  }

  // Attempt to select first swatch
  if (this.state.swatches) {
    this.selectSwatch(this.state.swatches[0].id);
  }
  
  rivets.formatters.money = function(cents) {
    return Shopify.formatMoney(cents);
  }
  
  rivets.formatters.empty = function(arr) {
    return arr.length < 1;
  }
  
  rivets.formatters.divided_by = function(value, denominator) {
    return parseFloat(value) / parseFloat(denominator);
  }

  // Rivets doesn't seem to handle `rv-value` on an option element, so make a custom one
  rivets.binders['option-value'] = function($elem, value) {
    $elem.value = value;
  }

  rivets.binders['swatch-selected'] = function($elem, swatchId) {
    $elem.value = swatchId || '';
  } 

  rivets.binders['active-grade'] = function($elem, selectedGrade) {
    var $grades = $($elem);

    $grades.find('li').each(function() {
      $(this).attr('data-active', selectedGrade == $(this).attr('data-grade'));
    });
  }

  rivets.binders['active-swatch'] = function($elem, selectedSwatch) {
    var $swatches = $($elem);

    $swatches.find('.swatch').each(function() {
      selected = selectedSwatch ? selectedSwatch.id == $(this).attr('data-id') : false;
      $(this).attr('data-active', selected);
    });
  }

  rivets.binders['background-image'] = function($elem, url) {
    $($elem).css({ backgroundImage: "url('"+url+"')"});
  }

  rivets.binders['button-state'] = function($elem, unit) {
    var staged = _.find(self.state.selectedItems, function(item) {
      return item.unit.id == unit.id;
    });

    if (staged) {
      $($elem).attr('data-state', 'complete');
    } else {
      $($elem).attr('data-state', 'ready');
    }
  }

  rivets.bind($set, this.state);
  let zip_value = "";

   // document.addEventListener('click', function(e) {
   //    if (e.target.getAttribute('id') == 'update_address') {
   //      $(".zip-form-container").css("visibility", "hidden");
   //      $(".zip-form-container").css("opacity", 0);
   //      $(".delivery-region").text("Philadelphia, Ex");
   //      // $(".delivery-region").text(zip_value);
   //    }
   //  });

   $(document).on('change', '#code_zip', function() {
        if($(this).val().length > 6) {
          $(this).val($(this).val().slice(0,6));
        }
        var inputValue = $(this).val();
        console.log(inputValue);
        zip_value = inputValue;

    //  $.ajax({
    //   url: "https://maps.googleapis.com/maps/api/geocode/json?address=40202&key=AIzaSyBllZ2QM_pCVJMx5P2vY2TWekJxGHAkK6g",
    //   method: "GET",
    //   success: function(data) {
    //     console.log(data.results[0].formatted_address);
    //   }
    // });
      
    });

  

   $(document).on('click', '#update_address', function() {
       call_zip_server();
    });

   $(document).on('keypress', '#code_zip', function(e) {
      if (e.which == 13) {
          if($(this).val().length > 6) {
            $(this).val($(this).val().slice(0,6));
          }
          call_zip_server();
        }
    });

  function call_zip_server() {
    var zipCodePattern = /^\d{5}(-\d{4})?$/; // Matches 5 digits or 5-4 digits

    if (!zipCodePattern.test(zip_value)) {
        $(".no_dound_address").css("display", "block");
        $(".no_dound_address").text("USA zip code only ");
        return;
    } 
    
    $.ajax({
      // url: "https://ws.postcoder.com/pcw/PCWMZ-V826P-WUYPX-P6M5E/address/us/"+ zip_value + "?format=json&lines=3",
      url: "https://maps.googleapis.com/maps/api/geocode/json?address=" + zip_value + "&key=AIzaSyAgYrEdzsdZQ6Xxpkr_bWtfDh-j_k8kFJk",
      method: "GET",
      success: function(data) {
        if(data.length == 0){
          // $(".delivery-region").text("Can't find address.");
          $(".no_dound_address").css("display", "block");
          $(".no_dound_address").text("Hmm, we can't seem to locate this postal code.");
        }else{
          //$(".delivery-region").text(data[0].posttown + ", " + data[0].stateabbreviation);
          $(".delivery-region").text(data['results'][0].formatted_address.substring(0, data['results'][0].formatted_address.length - 10));
          $(".no_dound_address").css("display", "none");
          $(".zip-form-container").css("visibility", "hidden");
          $(".zip-form-container").css("opacity", 0);
          $("#code_zip").val("");
        }
      },
      error: function(jqXHR, textStatus, errorThrown) {
          console.log('HTTP status code:', jqXHR.status);
          // $(".delivery-region").text("Server error " + jqXHR.status);
          // $(".zip-form-container").css("visibility", "hidden");
          // $(".zip-form-container").css("opacity", 0);
          $(".no_dound_address").css("display", "block");
          $(".no_dound_address").text("Server Error Code: " + jqXHR.status);
      }
    });
  }

  
  $(".delivery-region" ).on( "click", function() {
    let visibility = $(".zip-form-container").css("visibility");
    if(visibility == 'visible'){
      $(".zip-form-container").css("visibility", "hidden");
      $(".zip-form-container").css("opacity", 0);
    }else{
      $(".zip-form-container").css("visibility", "visible");
      $(".zip-form-container").css("opacity", 1);
    }
  });

  function setDicsountPrice(){
  jQuery(".custom-discount-price").each(function(item, index){
      if (jQuery(this).html() && jQuery.isNumeric(jQuery(this).html())) {
        jQuery(this).html(new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD'
                }).format(jQuery(this).html() / 100 * (100 - discountPercent) / 100)
             ).removeClass("hidden");
      }
    })
}
  
};